import triggerTracking from '@blueprint/tracking';

const EVENT = 'GAEvent';
const CATEGORY = 'search_filters';

export const trackQuickSearchModalClose = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'click',
        eventLabel: 'quick_search_bar_close'
    });
};

export const trackQuickSearchModalUpdateResults = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'click',
        eventLabel: 'quick_search_bar_update'
    });
};
